export enum ChecklistTypeIdEnum {
  Inspection = 1,
  Document = 2
}

export const CHECKLIST_TYPES = [
  { id: ChecklistTypeIdEnum.Inspection, name: 'Inspection' },
  { id: ChecklistTypeIdEnum.Document, name: 'Document' }
] as const;

export const CHECKLIST_TYPE_NAME_KEYS: Record<ChecklistTypeIdEnum, string> = {
  [ChecklistTypeIdEnum.Inspection]: 'compliance.shared.checklistTypes.inspection',
  [ChecklistTypeIdEnum.Document]: 'compliance.shared.checklistTypes.document'
};

export type ChecklistTypeOption = typeof CHECKLIST_TYPES[number];

export function getChecklistTypeOption(type: string | number): ChecklistTypeOption | undefined {
  const normalizedType = `${type}`.toLowerCase();

  return CHECKLIST_TYPES.find(checklistType =>
    checklistType.id === type ||
    `${checklistType.id}` === normalizedType ||
    checklistType.name.toLowerCase() === normalizedType ||
    normalizedType.includes(checklistType.name.toLowerCase())
  );
}